import { IconComponent, IconSlug } from 'types/icons';

/** Keys a set's eager glob by slug. Slugs a set has no artwork for simply produce no key. */
export const toSlugMap = (modules: Record<string, unknown>) =>
  Object.fromEntries(
    Object.entries(modules).map(([path, Icon]) => [
      path.slice(path.lastIndexOf('/') + 1, -'.svg'.length),
      Icon
    ])
  ) as Partial<Record<IconSlug, IconComponent>>;
